<template>
  <v-layout>
    <v-dialog v-model="dialog" width="500" persistent>
      <v-form ref="form" v-model="valid">
        <v-card>
          <v-card-title>{{ getDialogTitle }}</v-card-title>
          <v-card-text class="pb-0">
            <v-row>
              <v-col cols="12" class="pb-0">
                <v-text-field
                  v-model="pregunta.textoPregunta"
                  label="Pregunta"
                  placeholder="Pregunta?..."
                  :rules="requiredRules"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pt-0">
                <v-textarea
                  v-model="pregunta.posiblesRespuestas"
                  placeholder="A, B, C..."
                  label="Posibles Respuestas"
                  outlined
                  dense
                  :rules="requiredRules"
                ></v-textarea>
              </v-col>
              <v-col cols="12" class="d-fex justify-center pt-0">
                <v-switch
                  v-model="pregunta.estado"
                  inset
                  class="pt-0 mt-2"
                  color="primary"
                  label="Estado Pregunta"
                ></v-switch>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="px-4 pt-0 pb-4">
            <v-btn color="primary" outlined @click="clear">Cancelar</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="guardar">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-flex class="px-10 py-5">
      <v-data-table
        :headers="headers"
        :items="preguntas"
        :search="search"
        :loading="loader"
        loading-text="Listando Datos..."
        class="elevation-1"
      >
        <template v-slot:top>
          <v-container class="px-5 py-4">
            <v-layout>
              <h2 class="py-2 pl-3">Listado de Preguntas - SISA</h2>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row class="mt-6 mb-4">
              <v-flex xs12 sm12 md6 class="px-2">
                <v-text-field
                  class="text-xs-center"
                  v-model="search"
                  append-icon="search"
                  label="Búsqueda"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-spacer></v-spacer>

              <v-flex
                xs12
                sm12
                md2
                class="text-center pt-3 mr-2"
                align-self-center
              >
                <v-btn color="blue" dark block @click="dialog = true">
                  Agregar
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
          <v-divider></v-divider>
        </template>

        <template v-slot:[`item.estado`]="{ item }">
          <v-chip :color="item.estado ? 'green' : 'red'" dark>
            {{ item.estado ? "Activo" : "Inactivo" }}
          </v-chip>
        </template>

        <template v-slot:[`item.editar`]="{ item }">
          <v-btn icon @click="detalles(item)">
            <v-icon>tab</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  name: "Preguntas",
  data: () => ({
    valid: true,
    pregunta: {
      preguntaId: null,
      encuestaId: "",
      textoPregunta: "",
      posiblesRespuestas: "",
      estado: false,
    },
    requiredRules: [(v) => !!v || "Campo requerido"],
    loader: false,
    editing: false,
    search: "",
    headers: [
      // { text: "ID", value: "extensionId", align: "center", width: 100 },
      { text: "Pregunta", value: "textoPregunta", align: "center" },
      {
        text: "Posibles Respuestas",
        value: "posiblesRespuestas",
        align: "center",
      },
      { text: "Estado", value: "estado", align: "center" },
      { text: "Editar", value: "editar", align: "center", width: 100 },
    ],
    preguntas: [],
    dialog: false,
    cartera_nombre: "",
    expediente: "",
    flag: 1,
  }),
  created() {
    this.listar();
  },
  computed: {
    getDialogTitle() {
      return this.pregunta.preguntaId == null
        ? "Nueva Pregunta"
        : "Editar Preguna";
    },
  },
  methods: {
    listar() {
      this.loader = true;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("/Sisa/Preguntas", configuracion)
        .then((res) => (this.preguntas = res.data))
        .catch((err) => console.error(err))
        .finally(() => (this.loader = false));
    },
    guardar() {
      if (this.$refs.form.validate()) {
        if (this.pregunta.preguntaId == null) {
          this.nueva();
        } else {
          this.editar();
        }
      }
    },
    nueva() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .post(
          "/Sisa/Preguntas",
          {
            encuestaId: 1,
            textoPregunta: this.pregunta.textoPregunta,
            posiblesRespuestas: this.pregunta.posiblesRespuestas,
            estado: this.pregunta.estado,
          },
          configuracion
        )
        .then((res) => {
          this.listar();
          this.clear();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    editar() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .put(
          `/Sisa/Preguntas/${this.pregunta.preguntaId}`,
          {
            encuestaId: this.pregunta.encuestaId,
            textoPregunta: this.pregunta.textoPregunta,
            posiblesRespuestas: this.pregunta.posiblesRespuestas,
            estado: this.pregunta.estado,
          },
          configuracion
        )
        .then(() => {
          this.listar();
          this.clear();
        })
        .catch((err) => console.error(err));
    },
    detalles(item) {
      this.dialog = true;
      this.pregunta = { ...item };
    },
    clear() {
      this.dialog = false;
      this.$refs.form.resetValidation();
      this.pregunta = {
        preguntaId: null,
        encuestaId: "",
        textoPregunta: "",
        posiblesRespuestas: "",
        estado: false,
      };
    },
  },
};
</script>